import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { ReviewsPageBody } from "../components/ReviewsPageBody";

export const Template = (
    props: Immutable<templates.ReviewsPageDocumentTemplate>,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <ReviewsPageBody {...props} />
    </PageSkeleton>
);
